// extracted by mini-css-extract-plugin
export var content = "_2p-3";
export var contentWrapper = "_2p-2";
export var fullWidthButton = "_2p-4";
export var heroImage = "_2p-6";
export var logo = "_2p-1";
export var logoContainer = "_2p-0";
export var panel = "_2p-5";